<template>
    <div>
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
            <div>                                                         
            <div>
                <div class="row">
                <div class="col">
                <jet-button class="bg-blue-500 rounded text-white hover:bg-blue-500  hover:no-underline px-2 cursor-pointer  text-sm" @click="goToCreate"> Add {{moduleName}}</jet-button>
                </div>
                </div>
                <div class="mt-2">
                <div class="bg-white overflow-hidden shadow-xl px-2 py-2 sm:rounded-lg">
                <BsIndex :routeDef="moduleRoute"  :headersDef="headers">
                </BsIndex>  
                </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>

import BsIndex from '@/Base/BsIndex.vue'
import JetNavLink from '@/Jetstream/NavLink.vue'
import JetButton from "@/Jetstream/Button.vue";

export default {
    props: {
          moduleRoute:String,
          headers:Array,
          moduleName: String,
        },
        components: {
             BsIndex,
             JetNavLink,
             JetButton,
        },
    methods: {
        goToCreate() {
            this.$inertia.get(this.moduleRoute + '/create');
        },
    },
}
</script>

<style>

</style>